// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ditto: PokeData = {
  "id": 132,
  "name": "ditto",
  "height": 3,
  "weight": 40,
  "base_experience": 101,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "transform"
  ],
  "moves": [
    "tri-attack",
    "scratch",
    "leer",
    "splash",
    "protect",
    "refresh",
    "body-slam",
    "purification",
    "supersonic",
    "headbutt",
    "tackle",
    "quick-attack",
    "growl"
  ],
  "evolution_chain": {
    "id": 66,
    "item": null,
    "species": [
      {
        "name": "ditto",
        "order": 156,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 96,
    "speed": 96,
    "ability_power": 96
  },
  "stat_changes": [],
  "catch_rate": 35,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
